import { useCallback, useEffect, useState } from 'react';

export const useIsVideo = (url: string) => {
  const [isVideo, setIsVideo] = useState<boolean>(null);

  const checkVideo = useCallback((): Promise<boolean> => {
    return new Promise((res, rej) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = handleMetadataLoaded;
      video.onerror = handleVideoError;
      video.src = url;

      function handleMetadataLoaded() {
        res(!!(video.videoHeight && video.videoWidth));
        video.remove();
      }

      function handleVideoError(e: Event) {
        rej(e);
        video.remove();
      }
    });
  }, [url]);

  useEffect(() => {
    if (!url) return;

    checkVideo()
      .then(res => {
        setIsVideo(res);
      }).catch(() => {
        setIsVideo(false);
      });
  }, [checkVideo, url]);

  return isVideo;
};